<template lang="html">
  <section class="results" id="results">
    <div class="mt-4 pt-2" v-if="loading==='Complete' && tavnit && countResults===0">

      <div>
        {{hebrew ? 'לא נמצאו תוצאות' : 'No results found'}}
      </div>
    </div>
    <ResultsHeading 
      v-if="!showNoResults" 
      :resultsNum="countResults" 
      :more="additionalResults"
      :listDisplayed="currentWordList"
      >
    </ResultsHeading>
    <div 
      v-if="loading==='Complete'" 
      class="frame-area bg-white" 
      :class="{'invisible':countResults==0}"
    >     
      <ResultsList 
        :list="'general'" 
        v-if="defaultMode" 
        @results="updateCount('countItems', ...arguments)" 
        @word-list="(list) => currentWordList=list"
      />
      <ResultsList 
        :list="'common'" 
        v-if="commonMode"  
        @commonResults="updateCount('countItems', ...arguments)"
        @word-list="(list) => currentWordList=list"
      />
      <ResultsList 
        :list="'ns'" 
        v-if="nsMode" 
        @nsResults="updateCount('countItems', ...arguments)"
        @word-list="(list) => currentWordList=list"
      />
      <ResultsList 
        :list="'long'" 
        v-if="longMode" 
        @longResults="updateCount('countItems', ...arguments)"
        @word-list="(list) => currentWordList=list"
      />
      <ResultsList 
        :list="'fem'" 
        v-if="femMode"  
        @femResults="updateCount('countItems', ...arguments)"
        @word-list="(list) => currentWordList=list"
      />      
  
    </div>
  </section>
</template>

<script lang="js">
  import ResultsHeading from '@/components/ResultsHeading'
  import ResultsList from '@/components/ResultsList'
  
  export default  {
    name: 'Results',
    components: {ResultsHeading, ResultsList},
    props: [],
    data() {
      return {
        showNoResults: false,
        countResults: 0,
        defaultCountResults: 0,
        commonCountResults: 0,
        additionalResults: false,
        metaDesc: 'כלי החרוזית מאתר חרוזים, מצלול, אליטרציה ותבנית מילה על בסיס מילת חיפוש. ניתן לסנן את תוצאות החיפוש על ידי הזנת מילים משדה סמנטי מסויים ומאפינים דיקדוקיים.',
        currentWordList: []
      }
    },
    mounted() {
      
    },
    methods: {
      updateCount: function(countItems, value, fMore, topTenResults) {
        this.countResults = value
        if(value == 0) {
          //if ((!this.commonMode && this.countResults < 1) || (this.commonMode && this.commonCountResults < 1)) {
          this.showNoResults = true          
        } else {          
          this.showNoResults = false
          this.additionalResults = fMore
          if (this.loading === 'Complete') {
            var desc = 'חרוזים למילה ' + this.searchWord + ': ' + topTenResults + ' ועוד... '
            desc += this.metaDesc
            document.querySelector('meta[name="description"]').setAttribute("content", desc)
          }  
          if(this.defaultMode && !this.commonMode) {
            this.defaultCountResults = value
            this.countResults = value
          }
          else if(!this.defaultMode && this.commonMode) {
            this.commonCountResults = value
            this.countResults = value
          } 
          else if(this.defaultMode && this.commonMode) {
            if(this.commonCountResults === 0)
              this.commonCountResults = value
            this.countResults = this.defaultCountResults + this.commonCountResults
            this.additionalResults = this.countResults > 300
          }           
          else {            
           // this.countResults = value
          }          
        }
      } 
    },
    computed: {
      searchWord  () {
        return this.$store.state.textForCharuzitApiCall
      },      
      loading () {
        return this.$store.state.charuzitApiState
      },
      defaultMode () {
        return this.$store.state.displayDefault
      },
      commonMode () {
        return this.$store.state.displayCommon
      },
      femMode () {
        return this.$store.state.displayFem
      },
      nsMode () {
        return this.$store.state.displayNS
      },
      longMode () {
        return this.$store.state.displayLong
      },
      tavnit () {
        return this.$store.state.searchModel === 'tavnit'
      },
      hebrew () {
        return this.$settings.hebrew
      },
      mobile () {
        return this.$mq === 'xs'
      }
    },
    watch: {
      loading: function() {
        if (this.loading === 'Complete') {
          this.showNoResults = false
        }  
      }
    }
}
</script>

<style scoped lang="scss">
  .results {
    .frame-area{
      min-height:435px;
      border-radius: 6px;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
    }
  }
</style>
